import React from 'react';
import { Link } from 'react-router-dom';
import UIBox from 'components/ui/UIBox';
import UICard from 'components/ui/UICard';
import UIFlex from 'components/ui/UIFlex';
import UIText from 'components/ui/UIText';
import ProgressBar from 'components/ProgressBar';

interface ISubCategoryProgressCardProps {
  learned: number;
  added: number;
  total: number;
  totalTopics: number;
  accent: string;
  resumeLink?: string;
}

const SubCategoryProgressCard: React.FC<ISubCategoryProgressCardProps> = ({
  learned,
  added,
  total,
  totalTopics,
  accent,
  resumeLink,
}) => {
  const percent = total ? Math.round((learned * 100) / total) : 0;

  const button = (
    <UIBox
      sx={{
        alignItems: 'center',
        bgcolor: accent,
        borderRadius: 1,
        color: '#fff',
        display: 'flex',
        fontSize: 15,
        fontWeight: 700,
        gap: 1,
        height: 44,
        justifyContent: 'center',
        opacity: resumeLink ? 1 : 0.5,
        pointerEvents: resumeLink ? 'auto' : 'none',
        transition: 'opacity .15s ease',
        '&:hover': { opacity: resumeLink ? 0.92 : 0.5 },
      }}
    >
      {`Продовжити навчання · ${percent}%`}
      <UIBox component={'span'} sx={{ display: 'inline-block' }}>
        {'→'}
      </UIBox>
    </UIBox>
  );

  return (
    <UICard
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flex: 'none',
        flexDirection: 'column',
        gap: 1.75,
        maxWidth: '100%',
        p: '18px 20px',
        width: { xs: '100%', md: 420 },
      }}
    >
      <UIFlex ai={'baseline'} jc={'space-between'} sx={{ flexWrap: 'nowrap', gap: 1 }}>
        <UIText
          sx={{
            color: accent,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: '0.09em',
            textTransform: 'uppercase',
          }}
        >
          {'Прогрес у підкатегорії'}
        </UIText>
        <UIText color={'primary.subtitle'} sx={{ fontSize: 13 }}>
          {`${totalTopics} тем · ${total} слів`}
        </UIText>
      </UIFlex>

      <ProgressBar
        addedValue={added}
        learnedValue={learned}
        totalValue={total}
        minWidth={'100%'}
        maxWidth={'100%'}
        width={'100%'}
      />

      {resumeLink ? <Link to={resumeLink}>{button}</Link> : button}
    </UICard>
  );
};

export default SubCategoryProgressCard;
